"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.setRouter = void 0;
// ----------- import Packs
var react_1 = __importDefault(require("react"));
// ----------- import Internals
var Router_1 = require("./Router");
var useChangeRoutes_1 = require("./SetCurrSc/useChangeRoutes");
var SetCurrSc_1 = require("./SetCurrSc");
// ----------- export Function
var setRouter = function () {
    // ----------- set Data
    var getFn;
    // ----------- set Current Screen Component
    var SetCurrSc = function (props) {
        var passChanges = (0, useChangeRoutes_1.useChangeRoutes)(props.info);
        getFn = passChanges.setRouteData;
        var infoComp = { props: props, passChanges: passChanges };
        // ----------- set Return
        return react_1["default"].createElement(SetCurrSc_1.CompCurrClean, { infoComp: infoComp });
    };
    // ----------- set GoTo Function
    var goTo = function (path) {
        getFn(path);
    };
    // ----------- set Router Component
    var Router = function (props) {
        var newProps = __assign(__assign({}, props), { SetCurrSc: SetCurrSc });
        return react_1["default"].createElement(Router_1.RouterComp, __assign({}, newProps));
    };
    // ----------- set Return
    var fnItems = { Router: Router, goTo: goTo };
    return fnItems;
};
exports.setRouter = setRouter;
